var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fillRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 Profile Fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile_filled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 6.87488C3.37664 6.87488 2.0625 7.53113 2.0625 9.06238C2.0625 9.78863 3.82453 10.3749 6 10.3749C8.17547 10.3749 9.9375 9.78863 9.9375 9.06238C9.9375 7.53113 8.62336 6.87488 6 6.87488Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 6.43738C6.98438 6.43738 7.96875 5.25613 7.96875 3.81238C7.96875 2.06238 6.73829 1.62488 6.00001 1.62488C5.26172 1.62488 4.03125 2.06238 4.03125 3.81238C4.03125 5.25613 5.01563 6.43738 6.00001 6.43738Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.0595db0be9ca628a5c1c10ce058c5067.svg";
export { ForwardRef as ReactComponent };